import React, { Component } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import { renderRoutes } from '../lib/react-router-config';
import PendingNavDataLoader from './routing/PendingNavDataLoader';
import ScrollToTop from './routing/ScrollToTop';
import routes from './routes';
import feedRoutes from '../feed/routes';

const DevTools = __DEVTOOLS__ ? require('./redux/devtools').default : null;

export default class Provider extends Component {
  routes() {
    const { host, pathname } = window.location;
    if (__CLIENT__) {
      // TODO: set global js variable (during SSR), which is read and then cleared in the client
      const loc = `${host}${pathname}`;
      const mapping = {
        'www.billigmobil.dk/': '/mobilabonnement',
        'www.telefonselskaber.dk/': '/mobilabonnement',
        'www.tvpakke.dk/': '/tv-udbydere',
        'www.tvudbyder.dk/': '/tv-udbydere',
        'www.tvudbydere.dk/': '/tv-udbydere'
      };
      const mapped = mapping[loc];
      if (mapped) {
        return renderRoutes(/feed/.test(host) ? feedRoutes : routes, {}, { location: { pathname: mapped } });
      }
    }
    return renderRoutes(/feed/.test(host) ? feedRoutes : routes);
  }

  router() {
    return (
      <Router>
        <PendingNavDataLoader routes={routes}>
          <ScrollToTop>{this.routes()}</ScrollToTop>
        </PendingNavDataLoader>
      </Router>
    );
  }

  render() {
    return __DEVTOOLS__ ? (
      <content>
        {this.router()}
        <DevTools />
      </content>
    ) : (
      this.router()
    );
  }
}

//
// import React from 'react';
// import { Provider as ReduxProvider } from 'react-redux';
// import getRoutes from './routes';
// import { Router, browserHistory, match } from 'react-router';
// import { handleDataDependencies } from '../lib/ssr/fetch-data';
//
// export default ({ history = browserHistory, store }) => {
//   let provider = null;
//
//   const routes = getRoutes(store);
//   const router = (
//     <Router onUpdate={() => window.scrollTo(0, 0)} history={history}>
//       {routes}
//     </Router>
//   );
//
//   history.listenBefore((location, callback) => {
//     match(
//       { history, location, routes },
//       (error, redirectLocation, renderProps = {}) => {
//         handleDataDependencies({ location, store, renderProps })
//           .then(() => callback())
//           .catch(err => {
//             if (__DEV__) {
//               console.error(err);
//             }
//             return callback();
//           })
//           .then(() =>
//             handleDataDependencies({
//               location,
//               store,
//               renderProps,
//               deferred: true
//             })
//           )
//           .catch(err => {
//             if (__DEV__) {
//               console.error(err);
//             }
//           });
//       }
//     );
//   });
//
//   if (__DEV__ && __DEVTOOLS__) {
//     const DevTools = require('./redux/devtools').default;
//     provider = (
//       <Provider store={store}>
//         <div className="fs">
//           {router}
//           <DevTools />
//         </div>
//       </Provider>
//     );
//   } else {
//     provider = <Provider store={store}>{router}</Provider>;
//   }
//
//   return provider;
// };
